import {stripTags} from "@/lib/strip-tags";

export function ParagraphDefinitionCard({paragraph, ...props}) {
  return (
    <DefinitionCard title={paragraph.field_dc_title.processed} definition={paragraph.field_dc_definition.processed} />
  )
}

export function DefinitionCard({title, definition, ...props}) {
  return (
    <div className="paragraph--definition-card component-definition-card box-shadow-sm bg-white p-6">
      <h2 className="border-l-primary border-l-4 pl-3 [&>*]:font-bold text-xl [&>*]:text-xl [&>p]:pb-0 [&>p]:mb-0" dangerouslySetInnerHTML={{__html: stripTags(title)}} />
      <div className="pl-4 prose text-xl" dangerouslySetInnerHTML={{__html: definition}} />
    </div>
  );
}
